import { Field, Label, Switch } from '@headlessui/react';
import React, { useState } from 'react'
import { Oval } from  'react-loader-spinner'
import config from '../../../../../../config';

export default function LogoDesign({
    auctionData,
    handleLogoChange,
    handleLogoDelete,
    eventRightLogoLoader,
    eventLeftLogoLoader,
}) {
    const [enableRightLogo, setEnableRightLogo] = useState(auctionData?.event_display?.right_logo_image !== '');
    const [enableLeftLogo, setEnableLeftLogo] = useState(auctionData?.event_display?.left_logo_image !== '');

    const handleEnableRightLogoChange = (enabled) => {
        setEnableRightLogo(enabled);
        if (!enabled) {
            handleLogoDelete("event_right_logo");
        }
    }

    const handleEnableLeftLogoChange = (enabled) => {
        setEnableLeftLogo(enabled);
        if (!enabled) {
            handleLogoDelete("event_left_logo");
        }
    }

    return (
        <div className="px-2 pt-8">
            {/* <!-- right image switch --> */}
            <p className="text-sm font-semibold text-gray-700 mt-5">Right Logo</p>
            <Field className="pt-2 flex items-center">
                <Switch
                    checked={enableRightLogo}
                    data-testid='enableRightLogo'
                    onChange={handleEnableRightLogoChange}
                    className="group inline-flex h-6 w-11 items-center rounded-full
                        bg-gray-300 data-[checked]:bg-black mr-2"
                >
                    <span className="inline-block size-4 transform rounded-full bg-white transition 
                        group-data-[checked]:translate-x-6 translate-x-1" />
                </Switch>
                <Label>Enable right logo</Label>
            </Field>
            
            {/* <!-- right image content --> */}
            {enableRightLogo && auctionData.event_display.right_logo_image === '' && (
                <div className="w-full flex justify-center relative bg-[#E6E6E6] py-[22px] px-3 mt-2 rounded-md cursor-pointer">
                    <img src="/images/add-image-icon.svg" alt="logo-preview" loading="lazy" />
                    <label
                        htmlFor="auctionUpload"
                        className="font-medium text-center pl-2 text-[#343434] text-[10px] leading-normal"
                    >
                        {"Add image"}
                    </label>
                    <input
                        type="file"
                        data-testid='uploadRightLogo'
                        accept="image/jpeg, image/png, image/gif"
                        id="auctionUpload"
                        className="opacity-0 z-10 absolute cursor-pointer top-0 h-[58px] w-full"
                        onChange={(e)=>handleLogoChange(e, "event_right_logo")}
                    />
                    {eventRightLogoLoader && (
                        <Oval
                            height={20}
                            width={50}
                            color="#FFFFFF"
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#000000"
                            strokeWidth={2}
                            strokeWidthSecondary={2}
                        />
                    )}
                </div>
            )}
            {enableRightLogo && auctionData.event_display.right_logo_image !== '' && (
                <div className="w-full flex h-[84px] justify-center items-center relative bg-[#E6E6E6] px-3 mt-2 rounded-md">
                    <img
                        src={auctionData.event_display.right_logo_image.startsWith('blob:') 
                            ? auctionData.event_display.right_logo_image : 
                            `${config.Storage.CDN}${auctionData.event_display.right_logo_image}`}
                        alt="add-image-icon"
                        className='w-[125px] h-[65px]'
                        loading="lazy"
                    />
                    {eventRightLogoLoader && (
                        <div className='absolute left-[43%]' >
                            <Oval
                                height={25}
                                width={55}
                                color="#FFFFFF"
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#000000"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                            />
                        </div>
                    )}
                    <div className="flex justify-end absolute right-[15px] bottom-[15px] z-[11]">
                        <label
                            htmlFor="auctionUpload"
                            className="font-medium text-center pr-2 h-auto text-[#343434] 
                                text-[10px] leading-normal cursor-pointer"
                        >
                            <img data-testid='editRightLogo' 
                                src="/images/edit-icon-img.svg" className="cursor-pointer w-3.5" alt="edit" loading="lazy" />
                        </label>
                        <input 
                            type="file"
                            accept="image/jpeg, image/png, image/gif"
                            id="auctionUpload"
                            className="opacity-0 absolute cursor-pointer top-0 w-3 left-0 z-[-1]"
                            onChange={(e) => handleLogoChange(e,'event_right_logo')}
                        />
                        <img
                            src="/images/delete-icon-img.svg" 
                            data-testid='deleteRightLogo'
                            id ="delete-icon"
                            className="cursor-pointer"
                            alt="delete"
                            onClick={() => handleLogoDelete("event_right_logo")}
                            loading="lazy"
                        />
                    </div>
                </div>
            )}

            {/* <!-- left image switch --> */}
            <p className="text-sm font-semibold text-gray-700 mt-8">Alternative Left Logo</p>
            <Field className="pt-2 flex items-center">
                <Switch
                    checked={enableLeftLogo}
                    data-testid='enableLeftLogo'
                    onChange={handleEnableLeftLogoChange}
                    className="group inline-flex h-6 w-11 items-center rounded-full
                        bg-gray-300 data-[checked]:bg-black mr-2"
                >
                    <span className="inline-block size-4 transform rounded-full bg-white transition 
                        group-data-[checked]:translate-x-6 translate-x-1" />
                </Switch>
                <Label>Enable left logo</Label>
            </Field>

            {/* <!-- left image content --> */}
            {enableLeftLogo && auctionData.event_display.left_logo_image === '' && (
                <div className="w-full flex justify-center relative bg-[#E6E6E6] py-[22px] px-3 mt-2 rounded-md cursor-pointer">
                    <img src="/images/add-image-icon.svg" alt="logo-preview" loading="lazy" />
                    <label
                        htmlFor="auctionUpload"
                        className="font-medium text-center pl-2 text-[#343434] text-[10px] leading-normal"
                    >
                        {"Add image"}
                    </label>
                    <input
                        type="file"
                        data-testid='uploadLeftLogo'
                        accept="image/jpeg, image/png, image/gif"
                        id="auctionUpload"
                        className="opacity-0 z-10 absolute cursor-pointer top-0 h-[58px] w-full"
                        onChange={(e)=>handleLogoChange(e, "event_left_logo")}
                    />
                    {eventLeftLogoLoader && (
                        <Oval
                            height={20}
                            width={50}
                            color="#FFFFFF"
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#000000"
                            strokeWidth={2}
                            strokeWidthSecondary={2}
                        />
                    )}
                </div>
            )}
            {enableLeftLogo && auctionData.event_display.left_logo_image !== '' && (
                <div className="w-full flex h-[84px] justify-center items-center relative bg-[#E6E6E6] px-3 mt-2 rounded-md">
                    <img
                        src={auctionData.event_display.left_logo_image.startsWith('blob:') 
                            ? auctionData.event_display.left_logo_image : 
                            `${config.Storage.CDN}${auctionData.event_display.left_logo_image}`}
                        alt="add-image-icon"
                        className='w-[125px] h-[65px]'
                        loading="lazy"
                    />
                    {eventLeftLogoLoader && (
                        <div className='absolute left-[43%]' >
                            <Oval
                                height={25}
                                width={55}
                                color="#FFFFFF"
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#000000"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                            />
                        </div>
                    )}
                    <div className="flex justify-end absolute right-[15px] bottom-[15px] z-[11]">
                        <label
                            htmlFor="auctionUpload"
                            className="font-medium text-center pr-2 h-auto text-[#343434] 
                                text-[10px] leading-normal cursor-pointer"
                        >
                            <img data-testid='editLeftLogo' 
                                src="/images/edit-icon-img.svg" className="cursor-pointer w-3.5" alt="edit" loading="lazy" />
                        </label>
                        <input 
                            type="file"
                            accept="image/jpeg, image/png, image/gif"
                            id="auctionUpload"
                            className="opacity-0 absolute cursor-pointer top-0 w-3 left-0 z-[-1]"
                            onChange={(e) => handleLogoChange(e,'event_left_logo')}
                        />
                        <img
                            src="/images/delete-icon-img.svg" 
                            id ="delete-icon"
                            data-testid='deleteLeftLogo'
                            className="cursor-pointer"
                            alt="delete"
                            onClick={() => handleLogoDelete("event_left_logo")}
                            loading="lazy"
                        />
                    </div>
                </div>
            )}
        </div>
    )
}
